import SendAnnouncement from 'pages/Annoucement/SendAnnouncement';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'redux/store';
import { useEffect } from 'react';
import { fetchAnnouncementDetails } from 'redux/slices/announcements/announcementDetailSlice';

const EditAnnouncementContainer = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams();
    const { companyId, firstName, lastName, announcement } = useSelector((state: RootState) => ({
        companyId: state.user.defaultCompanyId,
        firstName: state.user?.userInfo?.firstName,
        lastName: state.user?.userInfo?.lastName,
        announcement: state.announcement.announcementDetails,
    }));
    const { details } = announcement || {};
    const { title = '', message = '', data } = details || {};
    const groupId = data?.announcementGroupId;
    const defaultValues = {
        title,
        message,
        companyId,
        data: {
            announcementGroupId: groupId ? Number(groupId) : null,
            notificationType: 'GENERAL_MESSAGE',
            firstName,
            lastName,
        },
    };

    useEffect(() => {
        if (details?.id !== Number(id) && id) {
            dispatch(fetchAnnouncementDetails(id));
        }
    }, [details?.id, id, dispatch]);

    return <SendAnnouncement defaultValues={defaultValues} />;
};

export default EditAnnouncementContainer;
